import React, { useState } from "react";

const SettledPayments = ({ settledPayments = [], employeeData }) => {
  const [openDate, setOpenDate] = useState(null);

  const toggleDate = (date) => {
    setOpenDate((prev) => (prev === date ? null : date));
  };

  // Empty state
  if (!settledPayments || settledPayments.length === 0) {
    return (
      <div className="w-full flex items-center justify-center py-16 bg-gray-50">
        <div className="max-w-md text-center bg-white rounded-2xl shadow border border-gray-200 px-6 py-8">
          <p className="text-sm text-gray-500 mb-2">Payments</p>
          <p className="text-lg font-semibold text-gray-900">
            No payment items available for{" "}
            <span className="text-[#7F58E6]">
              {employeeData?.fullName || "employee"}
            </span>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-gray-50">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-gray-200 bg-gray-50">
          <div>
            <p className="text-xs font-medium uppercase tracking-wide text-gray-500">
              Settled Payments
            </p>
            <p className="text-lg font-semibold text-gray-900">
              {employeeData?.fullName || "Employee"}
            </p>
          </div>
          <div className="mt-3 sm:mt-0 text-sm text-gray-500 flex flex-col items-start sm:items-end">
            <span className="font-medium">
              {settledPayments.length} day
              {settledPayments.length > 1 ? "s" : ""} of payments
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="p-4 sm:p-6">
          <div className="space-y-4">
            {settledPayments.map((group) => (
              <div
                key={group.date}
                className="border border-gray-200 rounded-xl overflow-hidden bg-white"
              >
                {/* Date row (accordion header) */}
                <button
                  type="button"
                  onClick={() => toggleDate(group.date)}
                  className="w-full flex items-center justify-between px-4 py-3 sm:px-5 sm:py-3.5 bg-white hover:bg-gray-100 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#7F58E6] text-white text-sm font-semibold">
                      {group.payments.length}
                    </span>
                    <div className="flex flex-col items-start">
                      <span className="text-sm font-medium text-gray-900">
                        {group.date}
                      </span>
                      <span className="text-xs text-gray-500">
                        {group.payments.length} payment
                        {group.payments.length > 1 ? "s" : ""}
                      </span>
                    </div>
                  </div>

                  <span className="text-gray-500 text-lg">
                    {openDate === group.date ? "−" : "+"}
                  </span>
                </button>

                {/* Payments list */}
                {openDate === group.date && (
                  <div className="bg-gray-50 border-t border-gray-200">
                    <ul className="divide-y divide-gray-200">
                      {group.payments.map((inv, idx) => (
                        <li
                          key={idx}
                          className="px-4 py-3 sm:px-5 sm:py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2"
                        >
                          <div className="flex-1">
                            <p className="text-sm font-semibold text-gray-900">
                              ₹{inv.settlementAmount ?? inv.price}
                            </p>
                            {inv.paymentType === "Split" && (
                              <p className="text-xs text-gray-400">
                                Booking total ₹{inv.price}
                              </p>
                            )}
                            <p className="text-xs text-gray-500">
                              Slot: {inv.timeSlot || "--"}
                            </p>
                          </div>

                          <div className="flex items-center gap-3 sm:gap-4 text-xs sm:text-sm">
                            <span className="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-gray-700 border border-gray-300">
                              {inv.paymentType || "Unknown"}
                            </span>
                            {inv.settlementMethod && (
                              <span className="inline-flex items-center rounded-full bg-blue-900/40 border border-blue-500/60 px-3 py-1 text-blue-300 text-xs font-medium">
                                via {inv.settlementMethod}
                              </span>
                            )}
                            <span className="inline-flex items-center rounded-full bg-emerald-900/40 border border-emerald-500/60 px-3 py-1 text-emerald-300 text-xs font-medium">
                              Settled
                            </span>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettledPayments;
